var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamDropDownImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_58_1121)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_58_1121",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_58_1121",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_58_1121",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADZklEQVR4nO2dzWoUURCFe6UrFcW/+ArqxuUQGPqcnpleGESGeQTBB9DHUFSi4k58hizVdRbZGSG4THaiqImKhISWkgkOwTHpn7nV3XMOFIRAkqrz3Vu3wxR9o0iSJEmSGqAkSa6QvA9gBcAmgB/jsK9X4ji+NxgMFrzzbJ0Gg8ECyVckd0lmR8QugJfdbveyd96tEMlbAL4ew/jD8QXAknf+jRaAuwD2C5j/J+xnkyS5411HIwVgCcBeUfMnINjvuOldT6PU7XbPA/hY1vwJCJ96vd5F77oaIwAvqjJ/Ip5719UIpWl6geTPqgEA+AXgUtQ2JUlyHcBjkusAvs9g5Wb/MHOT5LDT6ZyyAHCb5Eagv201rpN81Ov1rrkZn6bpSQDPyjylsKD5/X7/3OF87HsktwLnsg/g6Wg0OhHcfJJvQxbLvzGclheAkVNOb4JCsAPNqdDMWs60vNI0Pe2VF8nlkD1/v44AkiQ545WX/b8Rx/HVmQOww8dxlWV24P4nt6Fzbg9DAHjvWSTJjWmHMIAPzgDehQCw7Qwgs6cdO3Ct54/7/tDb/HFshwDgXWRW5xAACoD7KqR2gL8RVAvyN4MOoTOAAuC+Cqkd4G8E1YIaHWskEwCfdQYwvPmLi4tn7TAFcCMvBB3CrMb8A+WFIACszvwiEASA1ZqfF4IAMLf5q/ZBznGMi+O4LwCczYF7lMaftq0KAOtrfi1bkHc+UUnlMV8AWK0hec0XAFZnSBHzBYDVGFLUfAFgeUPKmC8ALGdIWfMFgMUNqcJ8AWAxQ6oyv5YA5i0iAaAAeK9Cagf4G0G1IH8z6BA6AygA7quQ2gH+RlAtqNGxprkg+pmvuSD6m38gzQXRz/wiEPQYymrNzwtBAJjbfM0FsUY9f5o0F8T6m1/LFuSdT1RSmgtyBKC5IEcAmgtyBKC5IEcAmgtyBKC5IEcAmgtyBKC5ILYnIu8VN+8RCQAFwHsVUjvA3wiqBfmbQYfQGUABcF+FbPkO2PEukjUNAN/m4dXFWV0j1KuLXV/ezRoHgAczB2DXdlRxvVTbAqFeX2+yazu8C2bNAsCTKJTsug67tsO7aNYkALwOfo/MGMLyPLcjAHu28oObPynre3ZzhD0BzMkj6o7VajUH6/mSJEmSJEmSJEmSJElS1Ab9BmjNkgKbMyErAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamDropDownImage);
export default __webpack_public_path__ + "static/media/exam_drop_down_image.658eb9dcbb4b0361f4ad86d367b2e40f.svg";
export { ForwardRef as ReactComponent };